import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app-footer" };
const _hoisted_2 = { class: "footer-content" };
const _hoisted_3 = { class: "footer-text" };
const _hoisted_4 = { class: "footer-links" };
import { useI18n } from '../../composables/useI18n';
import { computed, ref } from 'vue';
import PrivacyPolicyModal from './PrivacyPolicyModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppFooter',
    setup(__props) {
        const { t } = useI18n();
        const showPrivacyModal = ref(false);
        const currentYear = computed(() => {
            return new Date().getFullYear();
        });
        const openPrivacyPolicy = () => {
            showPrivacyModal.value = true;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("footer", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t).studio.name) + " © " + _toDisplayString(currentYear.value), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: "footer-link",
                                onClick: openPrivacyPolicy
                            }, _toDisplayString(_unref(t).footer?.privacyPolicy || 'Privacy Policy'), 1)
                        ])
                    ])
                ]),
                _createVNode(PrivacyPolicyModal, {
                    visible: showPrivacyModal.value,
                    onClose: _cache[0] || (_cache[0] = ($event) => (showPrivacyModal.value = false))
                }, null, 8, ["visible"])
            ], 64));
        };
    }
});
